module.exports = __webpack_public_path__ + "static/media/dellxps.da8f754e.jpg";